document.querySelectorAll('.klaviyo_form_trigger').forEach(function (triggerBtn) {
    triggerBtn.addEventListener('click', function () {
      const window_w = window.innerWidth;
      if (window_w > 768) {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'YyvrkE']);
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'WgJJUT']);
      }
    });
  });

  document.dispatchEvent(new Event('klaviyoBackInStockLoaded'));
  globalThis.klaviyo.showBackInStockModal();

